/* tslint:disable */
/* eslint-disable */
export enum WorkConnectorLinkResolutionEnum {
  AcceptSource = 'accept_source',
  KeepLocal = 'keep_local',
  Assign = 'assign',
  Create = 'create',
  Ignore = 'ignore'
}
